import React from 'react';
import { Platform, StyleSheet, View } from 'react-native';

import { theme } from '@garnish/constants';
import { IconLink } from '@garnish/core';

import { type HeaderLeftProps } from '../../Header.props';

export const HeaderLeft = (props: HeaderLeftProps) => {
  const { testID, items = [], tintColor } = props;

  const shouldRenderHeader = items.length > 0;

  if (!shouldRenderHeader) return null;

  return (
    <View testID={testID} style={styles.headerLeft}>
      {items.map(({ key, ref, icon, ...rest }) => (
        <IconLink
          key={key}
          ref={ref}
          width={36}
          height={36}
          name={icon}
          palette="muted"
          color={tintColor}
          {...rest}
        />
      ))}
    </View>
  );
};

// ─── Styles ──────────────────────────────────────────────────────────────────

const headerSidePadding = Platform.OS === 'web' ? theme.spacing['4'] : 0;

const styles = StyleSheet.create({
  headerLeft: {
    flexDirection: 'row',
    columnGap: theme.spacing['6'],
    paddingLeft: headerSidePadding,
    marginLeft: Platform.select({
      ios: -theme.spacing['1'],
      default: 0,
    }),
  },
});
